import validate from "/app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@24.6.2_@vue+compiler-sfc@3.5.22_better-sql_9fc23d2eb9a17365f2270e8c6c5a2c3a/node_modules/nuxt/dist/pages/runtime/validate.js";
import landing_45global from "/app/app/middleware/landing.global.ts";
import testing_45global from "/app/app/middleware/testing.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@24.6.2_@vue+compiler-sfc@3.5.22_better-sql_9fc23d2eb9a17365f2270e8c6c5a2c3a/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  landing_45global,
  testing_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/app/middleware/auth.ts")
}